<template>
  <div class="home">
    <v-layout
      v-if="!isProntuario || paciente === null"
      class="rounded rounded-md border"
    >
      <navigationDrawerRigth
        v-if="user && !isAutoLogin"
        :is-auto-login="isAutoLogin"
        @selecionado="itemSelecionado"
      />
      <navigationDrawerLeft v-if="false" />

      <!-- App Bar com Gradiente e Nome do Médico -->
      <v-app-bar
        v-if="user && !isAutoLogin"
        :order="order"
        class="gradient-app-bar"
        flat
        height="80"
      >
        <!-- Logo à Esquerda -->
        <div class="logo-container">
          <img
            :src="require(`@/assets/DRmed-01.png`)"
            class="ml-4"
            width="200"
            alt="DrMedPro"
          >
        </div>

        <v-spacer />

        <v-btn
          icon
          class="theme-toggle-btn"
          @click="toggleTheme"
        >
          <span class="material-icons">{{ isDark ? 'dark_mode' : 'light_mode' }}</span>
        </v-btn>

        <!-- Nome do Médico à Direita -->
        <div class="user-info-container">
          <v-avatar
            size="48"
            class="user-avatar mr-2"
          >
            <span class="material-icons user-avatar-icon">person</span>
          </v-avatar>
          <div class="user-details">
            <div class="user-name">
              {{ user?.nome || 'Médico' }}
            </div>
            <div class="user-role">
              Profissional
            </div>
          </div>
        </div>
      </v-app-bar>

      <v-main class="d-flex flex-column flex-grow-1 overflow-y-auto">
        <estatisticas
          v-show="page == 'TELA_INICIAL'"
          :is-visible="page == 'TELA_INICIAL'"
        />
        <laudo_clinico v-if="page == 'LAUDOS_TECNICOS'" />
        <prontuario-retorno v-if="page == 'PRONTUARIOS_RETORNO'" />
        <v-container
          v-if="page == 'ATENDIMENTO'"
          fluid
          class="fill-height pa-0 d-flex flex-column"
        >
          <configuracaoInicial
            v-if="isConfigura || !user?.servicosEscolhidos"
            :desabilitar-auto-selecao="configOpenedFromMenu"
            @configurar="configurar"
          />
          <div
            v-else
            class="fill-height w-100"
          >
            <pacientes-list
              @iniciou-atendimento="homeProntuarioOpen"
              @observar-prontuario="homeProntuarioOpen"
            />
          </div>
        </v-container>
      </v-main>
    </v-layout>
    <v-container
      v-else
      fluid
      class="pa-1 fill-height"
    >
      <home-prontuario
        :m-ficha="paciente"
        :tempo-atd="tempoAtd"
        @add-voltar="limparFicha"
      />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import configuracaoInicial from '../components/medico/configuracaoInicial.vue'
import pacientesList from '../components/medico/pacienteList.vue' 
import prontuarioRetorno from '@/components/medico/prontuarioRetorno.vue'
import navigationDrawerLeft from '@/components/medico/navigationDrawerLeft.vue'
import navigationDrawerRigth from '@/components/medico/navigationDrawerRigth.vue'
import homeProntuario from '@/components/medico/prontuario/homeProntuario.vue'
import estatisticas from '@/components/medico/estatisticas.vue'
import laudoClinico from '@/components/medico/laudoClinico.vue'
import { mapGetters, mapActions } from 'vuex'

import EventBus from '@/EventBus'
import { shallowRef } from 'vue'

const TIMER_STORAGE_PREFIX = 'drmed_atendimento_timer_'

const formatarTempo = (totalSegundos = 0) => {
    const horas = Math.floor(totalSegundos / 3600)
    const minutos = Math.floor((totalSegundos % 3600) / 60)
    const segundos = totalSegundos % 60
    return [horas, minutos, segundos].map(v => (v < 10 ? `0${v}` : `${v}`)).join(':')
}

const obterChaveTimer = (paciente) => {
    const idAtendimento = paciente?.idAtendimento || paciente?.id
    return idAtendimento ? `${TIMER_STORAGE_PREFIX}${idAtendimento}` : null
}

const carregarTimerArmazenado = (vm, paciente) => {
    if (typeof window === 'undefined') return null
    vm.currentTimerKey = obterChaveTimer(paciente)
    if (!vm.currentTimerKey) return null
    try {
        const bruto = localStorage.getItem(vm.currentTimerKey)
        return bruto ? JSON.parse(bruto) : null
    } catch (error) {
        console.warn('Não foi possível carregar o contador salvo.', error)
        return null
    }
}

const persistirTimerAtual = (vm) => {
    if (typeof window === 'undefined' || !vm.currentTimerKey) return
    try {
        localStorage.setItem(vm.currentTimerKey, JSON.stringify({
            seconds: vm.seconds,
            tempoAtd: vm.tempoAtd,
            atualizadoEm: new Date().toISOString()
        }))
    } catch (error) {
        console.warn('Não foi possível salvar o contador do atendimento.', error)
    }
}

const limparTimerArmazenado = (vm) => {
    if (typeof window === 'undefined' || !vm.currentTimerKey) return
    try {
        localStorage.removeItem(vm.currentTimerKey)
    } catch (error) {
        console.warn('Não foi possível remover o contador salvo.', error)
    }
}

const stopAttendanceTimer = (vm) => {
    if (vm.attendanceInterval) {
        clearInterval(vm.attendanceInterval)
        vm.attendanceInterval = null
    }
}

const startAttendanceTimer = (vm) => {
    stopAttendanceTimer(vm)
    vm.attendanceInterval = setInterval(() => {
        vm.seconds++
        vm.tempoAtd = formatarTempo(vm.seconds)
        persistirTimerAtual(vm)
    }, 1000)
}

const sincronizarTimerComPaciente = (vm, paciente) => {
    if (!paciente) return
    stopAttendanceTimer(vm)
    const armazenado = carregarTimerArmazenado(vm, paciente)
    if (armazenado && typeof armazenado.seconds === 'number') {
        vm.seconds = armazenado.seconds
        vm.tempoAtd = armazenado.tempoAtd || formatarTempo(armazenado.seconds)
    } else {
        vm.seconds = paciente.seconds || 0
        vm.tempoAtd = paciente.tempoAtendimento || formatarTempo(vm.seconds)
        persistirTimerAtual(vm)
    }
    startAttendanceTimer(vm)
}

const iniciarAtendimentoParaPacienteHelper = (vm, paciente, options = {}) => {
    if (!paciente) return
    const { skipStoreDispatch = false } = options
    if (!skipStoreDispatch) {
        vm.$store.dispatch('setPaciente', paciente)
    }
    vm.paciente = paciente
    vm.isProntuario = true
    sincronizarTimerComPaciente(vm, paciente)
}

const finalizarAtendimentoAtualHelper = (vm) => {
    limparTimerArmazenado(vm)
    stopAttendanceTimer(vm)
    vm.currentTimerKey = null
    vm.seconds = 0
    vm.tempoAtd = '00:00:00'
    vm.paciente = null
    vm.isProntuario = false
    vm.$store.dispatch('setPaciente', null)
}

export default {
    name: 'HomeView',
    components: {
        'pacientes-list': pacientesList,
        configuracaoInicial,
        navigationDrawerLeft,
        navigationDrawerRigth,
        'home-prontuario': homeProntuario,
        estatisticas,
        'laudo_clinico': laudoClinico,
        'prontuario-retorno': prontuarioRetorno
    },
    data: () => ({
        order: shallowRef(0),
        showLeft: true,
        isConfigura: false,
        configOpenedFromMenu: false,
        page: 'TELA_INICIAL',
        paciente: null,
        isProntuario: false,
        espera: false,
        pendente: false,
        tempoAtd: '00:00:00',
        seconds: 0,
        attendanceInterval: null,
        currentTimerKey: null
    }),
    watch: {
        isAutoLogin: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.abrirConfiguracaoInicial()
                }
            }
        }
    },
    mounted() {
        /* EventBus.on('paciente-selecionado', (data) => {
            this.paciente = data.paciente
            this.espera = data.espera
        }) */

        EventBus.on('addListaDeEspera', this.finalizarAtendimentoAtual)
        EventBus.on('encerrarAtd', this.finalizarAtendimentoAtual)
        this.paciente = this.$store.getters.paciente
        if (this.paciente !== null) {
            iniciarAtendimentoParaPacienteHelper(this, this.paciente, { skipStoreDispatch: true })
        }
        if (this.user?.servicosEscolhidos == null) {
            this.isConfigura = true
        }
    },
    beforeUnmount() {
        EventBus.off('paciente-selecionado');
        EventBus.off('addListaDeEspera', this.finalizarAtendimentoAtual);
        EventBus.off('encerrarAtd', this.finalizarAtendimentoAtual);
        stopAttendanceTimer(this);
    },
    computed: {
      ...mapGetters('theme', ['isDark']),
      user() {
          return this.$store.getters.usuario
      },
      isAutoLogin() {
          return Boolean(this.user?.autoLogin)
      }
    },
    methods: {
        ...mapActions('theme', ['toggleTheme']),
        irParaAtendimento() {
            this.itemSelecionado('ATENDIMENTO')
        },
        abrirConfiguracaoInicial({ fromMenu = false } = {}) {
            this.page = 'ATENDIMENTO'
            this.isConfigura = true
            this.configOpenedFromMenu = fromMenu
        },
        itemSelecionado(item) {
            switch (item) {
                case 'CONFIGURACAO':
                    this.abrirConfiguracaoInicial({ fromMenu: true })
                    break;
                case 'ATENDIMENTO':
                    this.page = 'ATENDIMENTO'
                    this.isConfigura = false
                    this.configOpenedFromMenu = false
                    break;
                case 'TELA_INICIAL':
                    this.page = 'TELA_INICIAL'
                    this.isConfigura = false
                    this.configOpenedFromMenu = false
                    break;
                case 'LAUDOS_TECNICOS':
                    this.page = 'LAUDOS_TECNICOS'
                    this.isConfigura = false
                    this.configOpenedFromMenu = false
                    break;
                case 'PRONTUARIOS_RETORNO':
                    this.page = 'PRONTUARIOS_RETORNO'
                    this.isConfigura = false
                    this.configOpenedFromMenu = false
                    break;
                default:
                    this.configOpenedFromMenu = false
                    break;
            }
        },
        limparFicha() {
            this.finalizarAtendimentoAtual()
        },
        setPaciente(paciente) {
            this.paciente = paciente
        },

        configurar(val) {
            this.isConfigura = val
            this.showLeft = !val
            if (!val) {
                this.configOpenedFromMenu = false
            }
        },
        homeProntuarioOpen(val) {
            iniciarAtendimentoParaPacienteHelper(this, val)
        },
        finalizarAtendimentoAtual() {
            finalizarAtendimentoAtualHelper(this)
        }
    }
}
</script>

<style scoped>
.fill-screen {
    /* height: 100vh !important; */ /* Removido para permitir que v-main gerencie a altura */
    width: 100vw !important;
    padding: 0 !important;
    margin: 0 !important;
}

.theme-toggle-btn {
  color: white;
  margin-right: 8px;
}

.gradient-app-bar {
    background: linear-gradient(135deg, rgb(var(--v-theme-primary)) 0%, rgb(var(--v-theme-secondary)) 100%) !important;
    box-shadow: 0 4px 20px rgba(var(--v-theme-primary), 0.3);
    position: relative;
    overflow: hidden;
}

.logo-container {
    display: flex;
    align-items: center;
    height: 100%;
}

.logo-container img {
    filter: brightness(0) invert(1);
}

.user-info-container {
    display: flex;
    align-items: center;
    margin-right: 24px;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 24px;
    border: 2px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
}

.user-avatar {
    background: rgba(255, 255, 255, 0.9) !important;
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.user-avatar-icon {
    color: rgb(var(--v-theme-primary));
    font-size: 24px;
}

.user-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 12px;
}

.user-name {
    color: white;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.2;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.user-role {
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.8rem;
    font-weight: 500;
    line-height: 1.2;
}

/* Responsividade */
@media (max-width: 768px) {
    .gradient-app-bar {
        height: 70px !important;
    }

    .logo-container img {
        width: 150px;
        margin-left: 8px;
    }

    .user-info-container {
        margin-right: 12px;
        padding: 6px 12px;
    }

    .user-avatar {
        width: 40px !important;
        height: 40px !important;
    }

    .user-name {
        font-size: 0.9rem;
    }

    .user-role {
        font-size: 0.75rem;
    }
}

@media (max-width: 480px) {
    .user-details {
        display: none;
    }

    .user-info-container {
        padding: 8px;
        background: rgba(255, 255, 255, 0.2);
    }

    .logo-container img {
        width: 120px;
    }
}
</style>
